module.exports = __webpack_public_path__ + "img/5.e03ab8f3.png";